export default __webpack_public_path__ + "static/media/29.03109f83.png";